/**
 * Whether the user has requested reduced motion at the OS/browser level.
 *
 * Shared by the instrument primitives (radial gauge, linear meter) and any imperative
 * motion (smooth `scrollIntoView`, JS-driven sweeps) so the `(prefers-reduced-motion: reduce)`
 * check lives in exactly one place instead of being copy-pasted per component. For
 * declarative CSS/Framer motion prefer the `@media (prefers-reduced-motion: reduce)` query
 * (or framer-motion's `useReducedMotion`); reach for this when you need the boolean in JS.
 *
 * Guards SSR / no-`matchMedia` environments by returning `false` (i.e. motion allowed).
 */
export const prefersReducedMotion = (): boolean =>
	typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
